// src/pages/SHEETALHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const SHEETALHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Learning & Development");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    { label: "Learning & Development", emoji: "📚" },
    { label: "Employee Productivity", emoji: "⚡" },
    { label: "Administration Zone", emoji: "🏛️" },
    { label: "Outcome for Citizen", emoji: "🧑‍🤝‍🧑" },
    { label: "Employee Self Reflection", emoji: "🪞" },
    { label: "SHEETAL Adoption", emoji: "🧗" },
  ];

  // FULL SHEETAL Menu Buttons
  const menuButtons1 = [
    // 📚 Learning & Development
    { label: "Employee Upskilling", emoji: "📚", link: "/sheetal-bookworld", group: "Learning & Development" },
    { label: "Digital Bookshelf", emoji: "📖", link: "/bookshelf", group: "Learning & Development" },
    { label: "Trainings & Workshops", emoji: "🎓", link: "/enroll/workshop", group: "Learning & Development" },
    { label: "Podcast", emoji: "️🎙️", link: "/podcast-mylist", group: "Learning & Development" },
    { label: "Ranking", emoji: "🏆", link: "/govthinkerscore", group: "Learning & Development" },
    { label: "Database", emoji: "💾", link: "/sheetaldb", group: "Learning & Development" },

    // SHEETAL Productivity
    { label: "Employee Work", emoji: "📘", link: "/sheetal-chronicles", group: "Employee Productivity" },
    { label: "Personal Diary", emoji: "📔", link: "/mydiary-home", group: "Employee Productivity" },
    { label: "DeepThinking Lab", emoji: "🧩", link: "/fivewhys-analysis-home", group: "Employee Productivity" },
    { label: "Goal-Board", emoji: "🎯", link: "/sheetal-goalboard", group: "Employee Productivity" },
    { label: "Kanban", emoji: "🗂️", link: "/sheetal-kanban", group: "Employee Productivity" },
    { label: "IKIGAI", emoji: "🌸", link: "/myprofile-ikigai", group: "Employee Productivity" },
    { label: "Work AI Counselling", emoji: "🧠", link: "/aicounselling", group: "Employee Productivity" },

    // SHEETAL Productivity
    { label: "Government Dashboard", emoji: "📘", link: "/sheetaldashboard", group: "Administration Zone" },

    // Outcome for Citizen
    { label: "Citizen Dashboard", emoji: "📘", link: "/sheetaldashboard", group: "Outcome for Citizen" },

    // 🪞 SHELF REFLECTION
    { label: "Personal Digital Card", emoji: "📘", link: "/sheetal-digitalcard", group: "Employee Self Reflection" },
    { label: "Self Management", emoji: "🙋‍♀️", link: "/sheetal-chronicles", group: "Employee Self Reflection" },
    { label: "Personal Diary", emoji: "📔", link: "/mydiary-home", group: "Employee Self Reflection" },
    { label: "Focus Timer", emoji: "⏱️", link: "/sheetal-focustimerstart", group: "Employee Self Reflection" },
    { label: "IKIGAI", emoji: "🌸", link: "/myprofile-ikigai", group: "Employee Self Reflection" },
    { label: "Personal AI Counselling", emoji: "🧠", link: "/aicounselling", group: "Employee Self Reflection" },

    // SHEETAL Adoption
    { label: "Stakeholders", emoji: "👨‍💼", link: "/sheetal-think5whysroles", group: "SHEETAL Adoption" },
    { label: "SHEETAL Advisor", emoji: "🤝", link: "/sheetal-advisors", group: "SHEETAL Adoption" },
  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-gray-950 text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-gray-900 border-b border-gray-800 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-300">SHEETAL</div>
          <div className="text-sm lg:text-m text-white">Systematic Holistic Efficiency Enhancement for Transparent Administration Leadership!</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-cyan-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 w-8 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                Login
              </button>
            </>
          )}
        </div>

        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-xl text-cyan-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-cyan-300 text-xs lg:text-sm">{userName}</div>
              <div className="flex gap-3">
                <button
                  onClick={handleLogout}
                  className="p-2 mt-4 rounded-md w-8 bg-red-600 hover:bg-red-700"
                >
                  ⏻
                </button>
              </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-cyan-300">Login</Link>
            </div>
          )}
        </div>
      )}

      <div className="bg-cyan-800 text-white text-xs sm:text-sm py-2">
        <div className="max-w-6xl mx-auto px-3 flex flex-wrap justify-center gap-4">
          <a href="/sheetal-about" className="hover:text-yellow-200">💭 About SHEETAL</a>
          <a href="/sheetal-faq" className="hover:text-yellow-200">🤔 FAQ</a>
          <a href="/agi" className="hover:text-yellow-200">🧠 AGI</a>   
          <a href="/agenticsim" className="hover:text-yellow-200">🤖 Ask AI</a>       
        </div>
      </div>

      <div className="mt-1 mb-1 px-3 py-2 border-b border-gray-500">
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 gap-2  border-gray-600 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-2 py-2 rounded-md text-xs sm:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-cyan-700 text-yellow-200"
                  : "bg-gray-800 text-gray-200 hover:bg-gray-700"
              }`}
              aria-pressed={activeTab === group.label}
            >
              <span className="text-lg">{group.emoji}</span>
              <span className="mt-1 text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 gap-0 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-gray-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1.5 py-1 rounded-md text-[10px] sm:text-xs font-medium transition bg-transparent hover:bg-cyan-700 hover:text-yellow-200 text-gray-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-base sm:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>

      <footer className="bg-gray-900 border-t border-gray-800 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© {new Date().getFullYear()} Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-cyan-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-cyan-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-cyan-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-cyan-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SHEETALHome;
